module.exports = __webpack_public_path__ + "static/media/1-Edit.3df35710.webp";